import { Component, OnInit } from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { MDBModalRef, MDBModalService } from "ng-uikit-pro-standard";
import {
  showError,
  showNotification,
  showSucess,
} from "src/app/shared/utils/functions/notification.function";

import { ModalEditarEmpresasComponent } from "../../components/modal-editar-empresas/modal-editar-empresas.component";
import { ModalValidateTokenComponent } from "../../components/modal-validate-token/modal-validate-token.component";
import { Password } from "../../models/password.model";
import { IUsuarioEmpresa } from "../../models/perfil.model";
import { PerfilService } from "../../services/perfil.service";
import { PasswordValidator } from "../../utils/password-validator";
import { encryptStorage } from "./../../../auth/utils/storage";
import { CognitoService } from "src/app/shared/services/cognito.service";
import { CognitoAttributes } from "src/app/shared/enum/cognito.enum";
import { ModalEditarRepresentanteComponent } from "../../components/modal-editar-representante/modal-editar-representante.component";
import { Empresa } from "src/app/auth/models/empresa.model";
import { StatusProcesso } from "../../models/processos.model";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-perfil-investidor",
  templateUrl: "./perfil-investidor.component.html",
  styleUrls: ["./perfil-investidor.component.scss"],
})
export class PerfilInvestidorComponent implements OnInit {
  formUpdateUsuario: FormGroup;
  formUpdateSenha: FormGroup;
  modalRef: MDBModalRef;
  status: StatusProcesso;

  usuario: IUsuarioEmpresa = new IUsuarioEmpresa();
  listaDdi: [] = [];

  emailVerified: boolean = false;
  dadosDoUsuario: any;

  constructor(
    private perfilService: PerfilService,
    private modalService: MDBModalService,
    private cognitoService: CognitoService,
    private router: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.createForm(new IUsuarioEmpresa());
    this.createFormSenha(new Password());

    this.usuario.documentoIdentificador = encryptStorage.getItem(
      "@documentoIdentificador"
    );
    this.emailVerified = encryptStorage.getItem("@emailVerified");
    this.createForm(this.usuario);
    this.buscarDadosUsuario();
    this.consultaInvestidor();
  }

  buscarDadosUsuario() {
    this.perfilService.listarDadosUsuario(this.usuario.documentoIdentificador).subscribe(
      (res) => {
        this.dadosDoUsuario = res;

        this.formUpdateUsuario.patchValue({
          nome: res.nome,
          email: res.email,
        })
    })
  }

  consultaInvestidor() {
    this.perfilService
      .listarEmpresas(this.usuario.documentoIdentificador)
      .subscribe(
        (res) => {
          this.usuario.empresas = res["data"];
        },
        (e) => console.log(e)
      );
  }

  createForm(usuario: IUsuarioEmpresa) {
    this.formUpdateUsuario = new FormGroup({
      documentoIdentificador: new FormControl({
        value: usuario.documentoIdentificador,
        disabled: true,
      }),
      nome: new FormControl({
        value: usuario.nome,
        disabled: true,
      }),
      email: new FormControl(usuario.email, [
        Validators.required,
        Validators.email,
      ]),
      confirmaEmail: new FormControl(usuario.email, [
        Validators.required,
        Validators.email,
      ]),
    });
  }

  createFormSenha(updateSenha: Password) {
    this.formUpdateSenha = new FormGroup({
      senhaAntiga: new FormControl(updateSenha.senhaAntiga, [
        Validators.required,
      ]),
      novaSenha: new FormControl(updateSenha.senhaNova, [
        Validators.required,
        PasswordValidator.strong,
        Validators.minLength(8),
      ]),
      confirmaSenha: new FormControl(updateSenha.confirmarSenha, [
        Validators.required,
      ]),
    });
  }

  updateUsuario() {
    if (this.email.value != this.confirmaEmail.value) {
      return showError("", "E-mails informados não coincidem.");
    }

    if (this.usuario.email === this.email.value && this.emailVerified) {
      return showNotification("", "Não houve alteração de E-mail");
    }

    if (this.formUpdateUsuario.invalid) {
      return showError(
        "",
        "Valide as informações do formulário para prosseguir."
      );
    }

    const dadosAtualizar = {
      ...this.dadosDoUsuario,
      nome: this.formUpdateUsuario.get("nome").value,
      email: this.email.value,
    }

    this.perfilService.updateDadosUsuario(this.usuario.documentoIdentificador, dadosAtualizar).subscribe(
        (res) => {
          return (this.modalRef = this.modalService.show(
            ModalValidateTokenComponent,
            {
              ignoreBackdropClick: true,
              scroll: true,
              data: {
                model: { ...this.usuario, email: this.email.value },
                emailVerified: this.emailVerified,
                modo: 'perfil',
              },
            }
          ));
        },
        (e) => {
          return showError(
            "",
            "Ocorreu um erro na solicitação, por favor tente novamente mais tarde."
          );
        },
        () => {}
      );
  }

  cadastrarEmpresa() {
    this.modalRef = this.modalService.show(ModalEditarEmpresasComponent, {
      ignoreBackdropClick: true,
      scroll: true,
      data: { model: this.usuario },
    });

    const instance = this.modalRef.content as ModalEditarEmpresasComponent;
    instance.closeCallback = () => {
      this.consultaInvestidor();
    };
  }

  updateEmpresa(empresa: Empresa) {
    this.modalRef = this.modalService.show(ModalEditarRepresentanteComponent, {
      ignoreBackdropClick: true,
      scroll: true,
      data: {
        empresa,
        cpfResponsavel: this.usuario.documentoIdentificador,
        idPedido: this.router.snapshot.paramMap.get("id"),
      },
    });

    const instance = this.modalRef.content as ModalEditarRepresentanteComponent;
    instance.closeCallback = () => {
      this.consultaInvestidor();
    };
  }

  updatePassword() {
    const { senhaAntiga, novaSenha, confirmaSenha } =
      this.formUpdateSenha.value;
    if (this.senhaNova.errors != null || this.senhaNova.errors != undefined) {
      if (this.senhaNova?.errors.strong || this.senhaNova?.errors.minlength) {
        return showError(
          "",
          "Sua senha precisa ter no mínimo 8 caracteres, 1 letra maiúscula, 1 letra minúscula, 1 caractere especial e 1 número."
        );
      }
    }

    if (novaSenha != confirmaSenha) {
      return showError("", "As senhas informadas não coincidem");
    }

    if (this.formUpdateSenha.invalid) {
      return showError(
        "",
        "Valide as informações do formulário para prosseguir."
      );
    }

    return this.cognitoService.changePassword(senhaAntiga, novaSenha).subscribe(
      (res) => {
        showSucess("", "Senha alterada com sucesso"),
          this.cognitoService.logout();
      },
      (e) => showError("", e.message)
    );
  }

  get documentoIdentificador() {
    return this.formUpdateUsuario.get("documentoIdentificador");
  }

  get nomeUsuario() {
    return this.formUpdateUsuario.get("nome");
  }

  get email() {
    return this.formUpdateUsuario.get("email");
  }

  get confirmaEmail() {
    return this.formUpdateUsuario.get("confirmaEmail");
  }

  get senhaAntiga() {
    return this.formUpdateSenha.get("senhaAntiga");
  }

  get senhaNova() {
    return this.formUpdateSenha.get("novaSenha");
  }

  get confirmaSenhaNova() {
    return this.formUpdateSenha.get("confirmaSenha");
  }
}
